export default "__VITE_ASSET__BtMhth_c__"